import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { ModalWrapperModule } from '../../../UI-Lib/Modal-Wrapper/modalWrapper.module';

export interface BrowseCharacteristicsComponentParams {
    descriptorCategories: any[];
}

@Component({
    selector: 'browse-characteristics',
    templateUrl: 'browseCharacteristics.component.html',
    imports: [ModalWrapperModule, TabsModule],
})
export class BrowseCharacteristicsComponent
    implements IWeissmanModalComponent<BrowseCharacteristicsComponentParams, Core.DescriptorDTO[]>, OnInit
{
    constructor(private readonly _bsModalRef: BsModalRef) {}

    params: BrowseCharacteristicsComponentParams;
    result: Core.DescriptorDTO[];

    descriptorCategories: any[];
    descriptorsToAdd: Core.DescriptorDTO[] = [];

    ngOnInit(): void {
        this.descriptorCategories = this.params.descriptorCategories;
    }

    cancel(): void {
        this._bsModalRef.hide();
    }

    save(): void {
        this.result = this.descriptorsToAdd;
        this._bsModalRef.hide();
    }

    descriptorClicked(descriptor: Core.DescriptorDTO, category: any, e): void {
        const categoryIdx = this.descriptorCategories.findIndex((x) => x.categoryId === category.categoryId);

        if (e.target.checked) {
            this.descriptorsToAdd.push(descriptor);
            this.descriptorCategories[categoryIdx].checkedCount++;
        } else {
            this.descriptorsToAdd = this.descriptorsToAdd.filter((d) => d !== descriptor);
            this.descriptorCategories[categoryIdx].checkedCount--;
        }
    }

    isDescriptorChecked(descriptor: Core.DescriptorDTO): boolean {
        return this.descriptorsToAdd.some((x) => x.descriptorID === descriptor.descriptorID);
    }

    clearSelection(): void {
        this.descriptorsToAdd = [];

        this.descriptorCategories = this.descriptorCategories.map((x) => {
            x.checkedCount = 0;
            return x;
        });
    }
}
